import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { formatSeconds } from '@playbookux/playbook-web-core';

import {
  CardFooter,
  CardLink,
  ContainerCard,
  DateCard,
  NoteCard,
  TitleCard,
  Icon,
  StatusProcessing,
} from './style';

const CardNote = (props) => {
  const {
    testSessionNote,
    onClipPlay,
    onCardClick,
    selected,
    isSelectable,
  } = props;

  const {
    createdAt,
    note,
    testSession,
    videoEndTime,
    videoStartTime,
    id,
    status,
  } = testSessionNote;

  const { tester } = testSession;

  const handleClickCard = () => {
    if (onCardClick) {
      onCardClick(id);
    }
  };

  const isProcessing = status === 'processed';

  return (
    <ContainerCard
      isSelectable={isSelectable}
      selected={selected}
      onClick={handleClickCard}
    >
      <TitleCard>
        {tester.project.name}
      </TitleCard>

      <NoteCard>
        {note}
      </NoteCard>

      <CardFooter>
        <DateCard>
          {moment(createdAt).format('ll')}
        </DateCard>

        {onClipPlay && (
          <>
            {isProcessing ? (
              <CardLink onClick={() => onClipPlay(testSessionNote.id)}>
                {`${tester.user.profile.firstName} `}
                {`${formatSeconds(videoEndTime - videoStartTime)} `}
                <Icon name="play" />
              </CardLink>
            ) : (
              <StatusProcessing>Processing</StatusProcessing>
            )}
          </>
        )}

      </CardFooter>
    </ContainerCard>
  );
};

CardNote.propTypes = {
  testSessionNote: PropTypes.shape({
    createdAt: PropTypes.string,
    note: PropTypes.string,
    testSession: PropTypes.shape({
      id: PropTypes.string,
      tester: PropTypes.shape({
        project: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
        user: PropTypes.shape({
          profile: PropTypes.shape({
            firstName: PropTypes.string,
          }),
        }),
      }),
    }),
    videoEndTime: PropTypes.number,
    videoStartTime: PropTypes.number,
    id: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  onClipPlay: PropTypes.func,
  onCardClick: PropTypes.func,
  selected: PropTypes.bool,
  isSelectable: PropTypes.bool,
};

CardNote.defaultProps = {
  onClipPlay: null,
  onCardClick: null,
  isSelectable: false,
  selected: false,
};

export default CardNote;
